import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as PlantListUserGuidActions from './plant-list-userguid.actions';
import { ArkikAlertService } from 'src/app/shared/components/arkik-alert/arkik-alert.service';
import { TranslationService } from 'src/app/core/services/common/translation.service';
import { map, switchMap, catchError, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectPlantListUserGuid } from './plant-list-userguid.selectors';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { PlantListUserGuidStoreService } from './plant-list-userguid.service';

@Injectable()
export class PlantListUserGuidEffects {
  constructor(
    private actions$: Actions,
    private plantListService: PlantListUserGuidStoreService,
    private alert: ArkikAlertService,
    private translation: TranslationService,
    private store: Store,
    private cookieService: CookieService,
  ) {}

  loadPlantListUserGuid$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlantListUserGuidActions.loadPlantListUserGuid),
      switchMap(() => {
        const userGuid = this.cookieService.get(environment.UserGuid).toUpperCase();
        const key = userGuid;
        return this.store.select(selectPlantListUserGuid(userGuid)).pipe(
          take(1),
          switchMap((plants) => {
            if (plants) {
              return of(PlantListUserGuidActions.loadPlantListUserGuidSuccess({ key, plants }));
            }
            return this.plantListService.getPlantListWithUserGuid().pipe(
              map((response) => PlantListUserGuidActions.loadPlantListUserGuidSuccess({ key, plants: response })),
              catchError((e) => {
                this.alert.error(e?.error?.message || this.translation.pt('views.globals.an-error-occurred'));
                return of(
                  PlantListUserGuidActions.loadPlantListUserGuidFailure({
                    error: e?.error?.message || this.translation.pt('views.globals.an-error-occurred'),
                    key,
                  }),
                );
              }),
            );
          }),
        );
      }),
    ),
  );

  refreshPlantListUserGuid$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlantListUserGuidActions.refreshPlantListUserGuid),
      map(() => PlantListUserGuidActions.resetPlantListUserGuid()),
    ),
  );
}
